export const formOptions = {
    rumahTinggalSendiri: [
      { value: "Ya", label: "Ya" },
      { value: "Tidak", label: "Tidak" }
    ],
    
    statusKeluarga: [
      { value: "Sudah Menikah & Kepala Keluarga", label: "Sudah Menikah & Kepala Keluarga" },
      { value: "Belum Menikah", label: "Belum Menikah" }
    ],
    
    apakahLokasiTanahSesuaiRTRW: [
      { value: "Sesuai", label: "Sesuai" },
      { value: "Tidak Sesuai", label: "Tidak Sesuai" }
    ],
    usiaPernikahan: [
        { value: "> 3", label: "> 3 Tahun" },
        { value: "< 3", label: "< 3 Tahun" }
      ],

    StatusKepemilikanTanah: [
        { value: "Milik Sendiri,Ada dokumen sah", label: "Milik Sendiri,Ada dokumen sah" },
        { value: "Bukan Milik Sendiri", label: "Bukan Milik Sendiri" }
      ],
    tingkatPenghasilanKeluarga: [
        { value: "< 2.5 jt", label: "< 2.5 jt" },
        { value: "2.5 - 4 jt", label: "2.5 - 4 jt" },
        { value: "> 4 jt", label: "> 4 jt" },
      ],
      
    
  };
  export const kecamatanOptions = {
    "Taliwang": [
      "Menala",
      "Dalam",
      "Sampir",
      "Kuang",
      "Bugis",
      "Arab Kenangan",
      "Telaga Bertong",
      "Tamekan",
      "Seloto",
      "Lamunga",
      "Batu Putih",
      "Banjar",
      "Sermong",
      "Labuhan Kertasari",
      "Labuhan Lalar",
      "Lalar Liang"
    ],
    "Seteluk": [
      "Seteluk Tengah",
      "Seteluk Atas",
      "Seran",
      "Rempe",
      "Tapir",
      "Air Suning",
      "Kelanir",
      "Lamusung",
      "Desa Loka",
      "Meraran"
    ],
    "Poto Tano": [
      "Poto Tano",
      "Kokarlian",
      "Tambak Sari",
      "Tebo",
      "Senayan",
      "Kiantar",
      "Tuananga",
      "Mantar"
    ],
    "Brang Rea": [
      "Lamuntet",
      "Rarak Ronges",
      "Bangkat Monteh",
      "Moteng",
      "Tepas Sepakat",
      "Tepas",
      "Sapugara Bree",
      "Seminar Salit",
      "Desa Beru"
    ],
    "Brang Ene": [
      "Lampok",
      "Mujahidin",
      "Kalimantong",
      "Manemeng",
      "Mataiyang",
      "Mura"
    ],
    "Jereweh": [
      "Dasan Anyar",
      "Goa",
      "Beru",
      "Belo"
    ],
    "Maluk": [
      "Benete",
      "Bukit Damai",
      "Mantun",
      "Pasir Putih",
      "Maluk"
    ],
    "Sekongkang": [
      "Talonang Baru",
      "Tatar",
      "Ai Kangkung",
      "Sekongkang Atas",
      "Tongo",
      "Kemuning",
      "Sekongkang Bawah"
    ]
  };
  
  
  
  export const kecamatanDesa = {
    "Taliwang": ["Menala", "Dalam", "Sampir", "Kuang", "Bugis", "Arab Kenangan", "Telaga Bertong", "Tamekan", "Seloto", "Lamunga", "Batu Putih", "Banjar", "Sermong", "Labuhan Kertasari", "Labuhan Lalar", "Lalar Liang"],
    "Seteluk": ["Seteluk Tengah", "Seteluk Atas", "Seran", "Rempe", "Tapir", "Air Suning", "Kelanir", "Lamusung", "Desa Loka", "Meraran"],
    "Poto Tano": ["Poto Tano", "Kokarlian", "Tambak Sari", "Tebo", "Senayan", "Kiantar", "Tuananga", "Mantar"],
    "Brang Rea": ["Lamuntet", "Rarak Ronges", "Bangkat Monteh", "Moteng", "Tepas Sepakat", "Tepas", "Sapugara Bree", "Seminar Salit", "Desa Beru"],
    "Brang Ene": ["Lampok", "Mujahidin", "Kalimantong", "Manemeng", "Mataiyang", "Mura"],
    "Jereweh": ["Dasan Anyar", "Goa", "Beru", "Belo"],
    "Maluk": ["Benete", "Bukit Damai", "Mantun", "Pasir Putih", "Maluk"],
    "Sekongkang": ["Talonang Baru", "Tatar", "Ai Kangkung", "Sekongkang Atas", "Tongo", "Kemuning", "Sekongkang Bawah"],
  };